module.exports = "https://web-assets.ifttt.com/packs/media/icons/shared-cc884926.png";